<template>
  <div>
    <v-row dense>
      <v-col align="center" sm="11">
        Version for Scheduling<br />(Select date range from dropdown list)
      </v-col>
      <v-col align="Right" sm="1">
        <v-menu open-on-hover top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="orange" small v-bind="attrs" v-on="on"
              >mdi-help</v-icon
            >
          </template>

          <v-list>
            <v-list-item
              ><a
                :href="NewsLetter"
                title="Newsletter Index"
                target="limsds_help"
                >Newsletter Index</a
              ></v-list-item
            >
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="3">
        <a
          :href="SSRSOutofLimitSampleReport"
          title="Out of Limit Sample Report"
          target="_top"
          >Out of Limit Sample Report</a
        >
      </v-col>
      <v-col align="center" sm="5">
        <a
          :href="SSRSOutofLimitSampleReportScheduled"
          target="_top"
          title="Out of Limit Sample Report Scheduled"
        >
          <v-icon> mdi-alarm </v-icon>
        </a>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="3">
        <a
          :href="SSRSSamplesbyProcessUnitandArea"
          title="Samples By Unit and Area"
          target="_top"
          >Samples by Process Unit and Area</a
        >
      </v-col>
      <v-col align="center" sm="5">
        <a
          :href="SSRSSamplesbyProcessUnitandAreaScheduled"
          target="_top"
          title="Samples By Unit and Area Scheduled"
        >
          <v-icon> mdi-alarm </v-icon>
        </a>
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col>
        <a :href="SSRSSampleAudit" title="Sample Audit Report" target="_top"
          >Sample Audit Report</a
        >
      </v-col>
      <v-col align="center"> </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
    </v-row>
    <br />
    <v-row dense>
      <v-col sm="2">
        <b>Specialty Reports</b>
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col sm="1"> </v-col>
      <v-col sm="2">
        <a
          :href="SSRSUSPBatchLotAnalysis"
          title="Formerly Propylene Glycol Report"
          target="_top"
          >USP Batch Lot Analysis</a
        >
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col sm="2">
        <b>Accounting Reports</b>
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col sm="1"> </v-col>
      <v-col sm="3">
        <a
          :href="SSRSSampleCountByShiftandDayOfWeek"
          title="Sample Count By Shift and Day Of Week"
          target="_top"
          >Sample Count By Shift and Day Of Week</a
        >
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col sm="1"> </v-col>
      <v-col sm="3">
        <a
          :href="SSRSTestCountByShiftandDayOfWeek"
          title="Test Count By Shift and Day Of Week"
          target="_top"
          >Test Count By Shift and Day Of Week</a
        >
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col sm="1"> </v-col>
      <v-col sm="3">
        <a
          :href="SSRSSampleandTestCountByUnitandArea"
          title="Sample and Test Count by Unit and Area"
          target="_top"
          >Sample and Test Count by Unit and Area</a
        >
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col sm="1"> </v-col>
      <v-col sm="3">
        <a
          :href="SSRSTestCountbyUnitandArea"
          title="Test Count by Unit and Area"
          target="_top"
          >Test Count by Unit and Area</a
        >
      </v-col>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
    </v-row>
    <v-row dense>
      <v-col sm="1"> </v-col>
      <v-col sm="4">
        <a
          :href="SSRSSamplePointViewedCount"
          title="Number of Times Sample Points have been Viewed"
          target="_top"
          >Number of Times Sample Points have been Viewed</a
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
export default {
  name: "Report",
  mixins: [uiView, appMixin],
  created() {
    let that = this;
    that.NewsLetter = that.settings.NewsLetter;
    that.SSRSOutofLimitSampleReport = that.settings.OutofLimitSampleReport;
    that.SSRSOutofLimitSampleReportScheduled =
      that.settings.OutofLimitSampleReportScheduled;
    that.SSRSSamplesbyProcessUnitandArea =
      that.settings.SamplesbyProcessUnitandArea;
    that.SSRSSamplesbyProcessUnitandAreaScheduled =
      that.settings.SamplesbyProcessUnitandAreaScheduled;
    that.SSRSSampleAudit = that.settings.SampleAudit;
    that.SSRSUSPBatchLotAnalysis = that.settings.USPBatchLotAnalysis;
    that.SSRSSampleCountByShiftandDayOfWeek =
      that.settings.SampleCountByShiftandDayOfWeek;
    that.SSRSTestCountByShiftandDayOfWeek =
      that.settings.TestCountByShiftandDayOfWeek;
    that.SSRSSampleandTestCountByUnitandArea =
      that.settings.SampleandTestCountByUnitandArea;
    that.SSRSTestCountbyUnitandArea = that.settings.TestCountbyUnitandArea;
    that.SSRSSamplePointViewedCount = that.settings.SamplePointViewedCount;
  },
  data() {
    return {
      SSRSOutofLimitSampleReport: null,
      SSRSOutofLimitSampleReportScheduled: null,
      SSRSSamplesbyProcessUnitandArea: null,
      SSRSSamplesbyProcessUnitandAreaScheduled: null,
      SSRSSampleAudit: null,
      SSRSUSPBatchLotAnalysis: null,
      SSRSSampleCountByShiftandDayOfWeek: null,
      SSRSTestCountByShiftandDayOfWeek: null,
      SSRSSampleandTestCountByUnitandArea: null,
      SSRSTestCountbyUnitandArea: null,
      SSRSSamplePointViewedCount: null,
    };
  },
};
</script>
<style lang="scss">
.v-input input {
  max-height: 15px;
}
</style>